import { defineComponent, computed, ref } from "vue";
import defaultAvatar from "../../assets/imgs/avatar.png.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Avatar",
  props: {
    imgSrc: null
  },
  setup(__props) {
    const props = __props;
    const src = computed(() => {
      if (isError.value) {
        return defaultAvatar;
      }
      return props.imgSrc || defaultAvatar;
    });
    const isError = ref(false);
    function handleError() {
      isError.value = true;
    }
    return { __sfc: true, props, src, isError, handleError };
  }
});
export {
  _sfc_main as default
};
